export const parsedReceiving = (data: any) => {
  const uniqueStoreIds = [...new Set(data.map((item: any) => item.storeId))];
  let map: any[] = [];
  uniqueStoreIds.map((idStore) => {
    let filterObj = data.filter((item: any) => item.storeId === idStore);
    let newObj = {
      id: filterObj[0].id,
      storeId: filterObj[0].storeId,
      categoryManagerId: filterObj[0].categoryManagerId,
      segundaFerragem: filterObj[0].segunda,
      tercaFerragem: filterObj[0].terca,
      quartaFerragem: filterObj[0].quarta,
      quintaFerragem: filterObj[0].quinta,
      sextaFerragem: filterObj[0].sexta,
      segundaChaparia: filterObj[1].segunda,
      tercaChaparia: filterObj[1].terca,
      quartaChaparia: filterObj[1].quarta,
      quintaChaparia: filterObj[1].quinta,
      sextaChaparia: filterObj[1].sexta,
      userId: filterObj[0].userId,
      updatedAt: filterObj[0].updatedAt,
      categoryManagerDescription: filterObj[0].categoryManagerDescription,
      storeDescription: filterObj[0].storeDescription,
      receivingSectorDescription: filterObj[0].receivingSectorDescription,
    };
    map.push(newObj);
  });
  return map;
};
